import {
  removeNullAttributes,
  queryStringFromObject,
  authHeader,
  handleResponse,
} from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getFuseProvisioning(queryParams) {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
  };
  const { sortOrder, sortBy } = { ...queryParams };
  delete queryParams.sortOrder;
  delete queryParams.sortBy;
  const sortQuery = sortOrder && sortBy ? `&sort=${sortBy}:${sortOrder}` : "";
  const queryObject = removeNullAttributes(queryParams);
  const query = queryStringFromObject(queryObject);

  const endPoint = `/api/admin/v1/iot/enrollments?${query}${sortQuery}`;

  return fetch(`${BASE_URL}${endPoint}`, requestOptions)
    .then(handleResponse)
    .then((data) => {
      return data;
    });
}

export const fuseProvisioningService = {
  getFuseProvisioning,
};
